/*
 * @Author: mayanxia 
 * @Date: 2022-05-07 08:43:16 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-12-15 14:13:18
 */

<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
        <detail-list :col="2" size="small">
            <detail-list-item :term="$t('设备编号')">{{model.meterId}}</detail-list-item>
            <detail-list-item :term="$t('上传时间')">{{model.sysTime}}</detail-list-item>
            <!-- <detail-list-item term="模组号">{{model.deviceId}}</detail-list-item> -->
            <detail-list-item :term="$t('SIM卡号')">{{model.meterSim}}</detail-list-item>
            <detail-list-item :term="$t('设备名称')">{{model.deviceName}}</detail-list-item>
            <detail-list-item :term="$t('安装位置')">{{model.deviceLocation}}</detail-list-item>
                
            <detail-list-item :term="$t('压力值(MPa)')">{{model.pvalue}}</detail-list-item>
            <detail-list-item :term="$t('温度(℃)')">{{model.tepvalue}}</detail-list-item>
            <detail-list-item :term="$t('总流量(m³)')">{{model.throughputTotal}}</detail-list-item>
            <detail-list-item :term="$t('正向流量(m³)')">{{model.throughput}}</detail-list-item>
            <detail-list-item :term="$t('反向流量(m³)')">{{model.throughputMinus}}</detail-list-item>
            <detail-list-item :term="$t('瞬时流量(m³)')">{{model.flow}}</detail-list-item>
            <detail-list-item :term="$t('流速(m³/h)')">{{model.speed}}</detail-list-item>
            <detail-list-item :term="$t('软件版本号')">{{model.softVersion}}</detail-list-item>
            <detail-list-item :term="$t('仪表电池电压(%)')">{{model.batteryValue}}</detail-list-item>
            <detail-list-item :term="$t('GPRS电池电压(%)')">{{model.uv}}</detail-list-item>
        </detail-list>
    </a-spin>
  </j-modal>
</template>

<script>

  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  export default {
    name: 'EmfFlowUpDataRecordModal',
    filters: {
      filterDictTextByCache
    },
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        width:800,
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/wq/emfFlowUpDataRecord/add",
          edit: "/jeecg-charge/wq/emfFlowUpDataRecord/edit",
        },
        meterSignal: {}
      }
    },
    computed: {
      title() {
        return this.$t('详情')
      },
      meterTypeName() {
        if(this.model.meterType) {
          let meterType = parseInt(this.model.meterType).toString(16)
          return  filterDictTextByCache('valve_device_type',meterType);
        }
        
      }
    },
    created () {
    },
    methods: {
      close () {
        this.$emit('close');
        this.visible = false;
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      handleOk () {
        const that = this;
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>